import React from 'react';
import TextField from '../shared/ppbn-textfield';
import '../../styles/createInvoice.css'
import { withStyles } from '@material-ui/core/styles';
import CurrencyInput from '../shared/CurrencyInput';
import config from '../../clientConfig';
import PaymentTypeSelectField from '../shared/payment-type-field';


const styles = theme => ({
    container: {
      display: 'flex',
        flexWrap: 'wrap',
    },
    paymentTypeContainer: {
        paddingLeft: 20,
        paddingTop: 10,
        paddingBottom:10
    },
    textField: {
      marginLeft: 20,
      marginTop: 15,      
      marginRight: theme.spacing.unit,
      width: 200,
    },
    serviceNotes: {
      marginLeft: 20,  
      marginRight: theme.spacing.unit,
      width: '655px',
    },
    menu: {
      width: 200,
    },
  });


class InvoiceForm extends React.Component {  
    dateChanged = (id,value) => {
        this.props.handleChange({ target : { id, value } })
    }   
    
    paymentTypeChanged = (e) => {
        this.props.handleChange({ target : { id: 'paymentType', value: e.target.value } })
    }
    
    paymentAndChargeDetails() {        
        const {handleChange, classes} = this.props;
        return (
            <div className="payments">
                <div className='invoice-sub-header'>Payment and Charge Details</div>
                <div className={classes.paymentTypeContainer}>
                    <PaymentTypeSelectField
                        id='paymentType'
                        classes={classes.formControl}
                        value={this.props.paymentType || ''}
                        onChange={(e) => this.paymentTypeChanged(e)}
                    />
                </div>
                <div className="payment-details">
                    <CurrencyInput
                        id='mileageCharges'
                        type="number"
                        value={this.props.mileageCharges}
                        className={classes.textField}
                        label='Mileage Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='timeCharges'
                        type="number"
                        value={this.props.timeCharges}
                        className={classes.textField}
                        label='Time Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='additionalCharges'
                        type="number"
                        value={this.props.additionalCharges}
                        className={classes.textField}
                        label='Additional Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='credits'
                        type="number"
                        value={this.props.credits}
                        className={classes.textField}
                        label='Credits'
                        onChange={handleChange} />
                    <TextField
                        value={this.props.paymentDate || ''}
                        label="Payment Date"
                        id='paymentDate'
                        InputLabelProps={{ shrink: true, }}
                        className={classes.textField}
                        onChange={(e) => this.dateChanged('paymentDate', e.target.value)}
                        type="date" />
                    <CurrencyInput
                        id='postedToReceivables'
                        type="number"
                        value={this.props.postedToReceivables}
                        className={classes.textField}
                        label='Posted To Receivables'
                        onChange={handleChange} />
                    <CurrencyInput
                        type="number"
                        id='invoiceTotal'
                        value={this.props.invoiceTotal}
                        className={classes.textField}
                        label='Invoice Total'
                        onChange={handleChange} />
                </div>      
            </div>
        )
    }

    render() {
        const { handleChange, classes, invoiceId } = this.props;
        return (
            <div className="invoice-form-container">
                <div className='invoice-sub-header'>    
                    <div>General Details {invoiceId ? <span className='invoice-sub-header-invoice-number'>(Editing Invoice: {`T${invoiceId}`})</span>: null}</div>                  
                </div>
                <TextField
                    id="location"
                    value={this.props.location || ''}    
                    inputProps={ {maxLength : 45}}
                    className={classes.textField}
                    label="Location"
                    onChange={handleChange}
                    margin="normal"
                />
                <TextField
                    id="unit"       
                    className={classes.textField}
                    value={this.props.unit || ''}                    
                    inputProps={ {maxLength : 20}}
                    label="Unit"
                    onChange={handleChange}
                    margin="normal"
                />                
                <TextField
                    value={this.props.dateTowed || ''}
                    label="Date Towed"
                    id='dateTowed'
                    InputLabelProps={{ shrink: true, }}
                    className={classes.textField}                    
                    onChange={(e) => this.dateChanged('dateTowed',e.target.value)}
                    type="date" />        
                <TextField
                    id="vehicle"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={this.props.vehicle || ''}
                    className={classes.textField}
                    inputProps={ {maxLength : 45}}                    
                    label="Vehicle"
                    onChange={handleChange}/>
                <TextField
                    id="hub"
                    type="number"
                    value={this.props.hub || ""}
                    className={classes.textField}
                    label={config.isPetroff ? "Hub" : "Mileage"} 
                    onChange={handleChange}
                /> 
                <TextField
                    id="towVehicle"
                    value={this.props.towVehicle || ''}                    
                    inputProps={ {maxLength : 10}}                    
                    className={classes.textField}
                    label="Tow Vehicle"
                    onChange={handleChange} />
                <TextField
                    id="companyPO"
                    value={this.props.companyPO || ''}                    
                    inputProps={ {maxLength : 255}}                    
                    className={classes.textField}
                    label="Company PO"
                    onChange={handleChange} />
                <TextField
                    id="referenceNumber"
                    value={this.props.referenceNumber || ""}                    
                    inputProps={ {maxLength : 20}}
                    className={classes.textField}
                    label="Reference Number"
                    onChange={handleChange} />
                <br />
                <br />
                <TextField
                    id='serviceNotes'                    
                    inputProps={ { maxLength : 1000 } }
                    value={this.props.serviceNotes || ""}                    
                    className={classes.serviceNotes}
                    label='Service Notes'
                    rows={3}
                    rowsMax={5}
                    multiline={true}
                    variant="outlined"
                    onChange={handleChange} />
                {this.paymentAndChargeDetails()}                 
            </div>
          )
    }
}

export default withStyles(styles)(InvoiceForm);
